import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { HistoryMessageList } from '@/components/history/HistoryMessageList'
import { describePlanner } from '@/lib/history'
import type { HistoryPreview } from '@/api/types'

interface HistoryPreviewCardProps {
  preview: HistoryPreview
  isStale: boolean
}

export function HistoryPreviewCard({ preview, isStale }: HistoryPreviewCardProps): React.ReactElement {
  const hasProblems = preview.problems.length > 0
  const isClean = !hasProblems && !isStale
  const description = isStale
    ? 'Posten har ändrats sedan förhandsgranskningen. Förhandsgranska igen innan du lägger in.'
    : hasProblems
      ? 'Inget skrivs förrän problemen är lösta.'
      : 'Inga problem. Allt nedan skrivs när du lägger in.'

  return (
    <Card className={`shadow-none ${isClean ? 'border-emerald-300' : 'border-border/80'}`}>
      <CardHeader>
        <CardTitle>Förhandsgranskning</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <HistoryMessageList
          title="Problem"
          messages={preview.problems}
          tone="problem"
        />
        <HistoryMessageList
          title="Ändrat i plattformen sedan avstämningen"
          messages={preview.drift}
          tone="warning"
        />
        <HistoryMessageList
          title="Capway nu, mot arbetslistan"
          messages={preview.capwayChanges}
          tone="info"
        />
        {preview.plannerAfter && <p>{describePlanner(preview.plannerAfter)}</p>}
        {preview.waitingForPostnord && (
          <p className="text-muted-foreground">Kunden har haft leveranserna avstängda för att paketen gick för hand.</p>
        )}
        {preview.note && (
          <div>
            <p className="font-medium">Anteckning på kundkortet</p>
            <p className="whitespace-pre-wrap text-muted-foreground">{preview.note}</p>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
